import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.function.name";
import React, { useRef } from 'react';
import { Label, MultiLabel, Input, Textarea, SwitchLabel, SwitcherWrap, Switcher, Radio, Header, Spacer } from './styles';

var preconditionFailed = function preconditionFailed(state, props, conditions) {
  if (conditions === void 0) {
    conditions = [];
  }

  return !conditions.every(function (condition) {
    switch (condition.type) {
      case 'fieldValue':
        return state.people[props.person][condition.field] && state.people[props.person][condition.field].value === condition.value;

      case 'meta':
        return state.meta[condition.field] === condition.value;

      case 'last':
        return props.last;

      default:
        return false;
    }
  });
};

var getState = function getState(_ref, option) {
  var state = _ref.state,
      person = _ref.person,
      field = _ref.field;
  var s = state.people[person][field.name] || {};

  switch (field.type) {
    case 'text':
    case 'textarea':
      return s.value || field.value || '';

    case 'radio':
      return s.value === option.value || s.value === undefined && option.checked || false;

    case 'checkbox':
      if (option) {
        s = state.people[person][field.name + "_" + option.value] || {};
      }

      if ('value' in s) {
        return s.value;
      }

      return (option ? option.checked : field.checked) || false;

    case 'switch':
    case 'guest':
      return s.value === field.value;

    default:
      return;
  }
};

function AutoResizeTextarea(props) {
  return /*#__PURE__*/React.createElement(Textarea, Object.assign({}, props, {
    onInput: function onInput(event) {
      event.target.style.height = '5px';
      event.target.style.height = event.target.scrollHeight + 'px';
    }
  }));
}

export default function Field(props) {
  var state = props.state,
      field = props.field,
      reduce = props.reduce,
      person = props.person;

  if (preconditionFailed(state, props, field.conditions)) {
    return null;
  }

  switch (field.type) {
    case 'block':
      return /*#__PURE__*/React.createElement(React.Fragment, null, field.fields.map(function (field, index) {
        return /*#__PURE__*/React.createElement(Field, Object.assign({
          key: index
        }, props, {
          field: field
        }));
      }));

    case 'header':
      return /*#__PURE__*/React.createElement(Header, null, field.title);

    case 'spacer':
      return /*#__PURE__*/React.createElement(Spacer, null);

    case 'text':
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Label, null, field.label ? /*#__PURE__*/React.createElement("span", null, field.label) : null, /*#__PURE__*/React.createElement(Input, {
        type: "text",
        name: field.name + "_" + person,
        value: getState(props),
        placeholder: field.placeholder,
        onChange: function onChange(e) {
          return reduce({
            type: 'SET_VALUE',
            payload: {
              field: field.name,
              sync: field.sync,
              person: person,
              value: e.target.value
            }
          });
        }
      })));

    case 'radio':
      return /*#__PURE__*/React.createElement(React.Fragment, null, field.label ? /*#__PURE__*/React.createElement(Header, null, field.label) : null, /*#__PURE__*/React.createElement(MultiLabel, null, field.options.map(function (option) {
        if (preconditionFailed(state, props, option.conditions)) {
          return null;
        }

        return /*#__PURE__*/React.createElement(Label, {
          key: option.value
        }, /*#__PURE__*/React.createElement(Radio, null, /*#__PURE__*/React.createElement("input", {
          type: "radio",
          name: field.name + "_" + person,
          value: option.value,
          checked: getState(props, option),
          onChange: function onChange() {
            return reduce({
              type: 'SET_VALUE',
              payload: {
                field: field.name,
                sync: field.sync,
                person: person,
                value: option.value
              }
            });
          }
        }), /*#__PURE__*/React.createElement("div", null)), field.important ? /*#__PURE__*/React.createElement("strong", null, option.label) : /*#__PURE__*/React.createElement("span", null, option.label));
      })));

    case 'switch':
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement("span", null, field.label), /*#__PURE__*/React.createElement(SwitcherWrap, null, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        name: field.name + "_" + person,
        checked: getState(props, field),
        onChange: function onChange(event) {
          return reduce({
            type: 'SET_VALUE',
            payload: {
              field: field.name,
              sync: field.sync,
              person: person,
              value: event.target.checked ? field.value : null
            }
          });
        }
      }), /*#__PURE__*/React.createElement(Switcher, null))));

    case 'checkbox':
      return /*#__PURE__*/React.createElement("div", null, field.options ? /*#__PURE__*/React.createElement(React.Fragment, null, field.label ? /*#__PURE__*/React.createElement(Header, null, field.label) : null, field.options.map(function (option) {
        var name = field.name + "_" + option.value;
        return /*#__PURE__*/React.createElement(Label, {
          key: name
        }, /*#__PURE__*/React.createElement("span", null, option.label), /*#__PURE__*/React.createElement(SwitcherWrap, null, /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          name: name + "_" + person,
          value: "yes",
          checked: getState(props, option),
          onChange: function onChange(event) {
            return reduce({
              type: 'SET_VALUE',
              payload: {
                field: name,
                sync: field.sync,
                person: person,
                value: event.target.checked
              }
            });
          }
        }), /*#__PURE__*/React.createElement(Switcher, null)));
      })) : /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        name: field.name + "_" + person,
        value: "yes",
        checked: getState(props),
        onChange: function onChange(e) {
          return reduce({
            type: 'SET_VALUE',
            payload: {
              field: field.name,
              sync: field.sync,
              person: person,
              value: e.target.checked
            }
          });
        }
      }), /*#__PURE__*/React.createElement("span", null, field.label)));

    case 'textarea':
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement("span", null, field.label), /*#__PURE__*/React.createElement(AutoResizeTextarea, {
        name: field.name + "_" + person,
        value: getState(props),
        cols: "20",
        onChange: function onChange(e) {
          return reduce({
            type: 'SET_VALUE',
            payload: {
              field: field.name,
              sync: field.sync,
              person: person,
              value: e.target.value
            }
          });
        }
      })));

    case 'guest':
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement("span", null, field.label), /*#__PURE__*/React.createElement(SwitcherWrap, null, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: getState(props, field),
        onChange: function onChange(event) {
          return reduce({
            type: 'SET_GUEST',
            payload: {
              field: 'guest',
              person: person,
              value: event.target.checked ? field.value : null
            }
          });
        }
      }), /*#__PURE__*/React.createElement(Switcher, null))));

    default:
      return null;
  }
}